import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import '../assets/css/home.css'
import { getAllCategories } from '../Api/categories';
// `getAllProductsByPage` import removed with the Featured grid; the only
// remaining references are inside commented-out blocks (DEBT-6).
import { getMediaByFolder, uploadPrescription } from '../Api/media';
import Loader from "../components/Loader";
import { FaCamera, FaWhatsapp } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Modal from "@mui/material/Modal";
import { Carousel } from 'antd';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AdVideoCard from "../components/VideoCard";
import CategoryRail from "../components/CategoryRail";


export default function Home({ isAuthenticated, onAddToCart }) {
  const navigate = useNavigate();
  const [category, setCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sliderImages, setSliderImages] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [prescription, setPrescription] = useState(null);
  const [uploadStatus, setUploadStatus] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [adVideo, setAdVideo] = useState([]);
  const [activeVideoId, setActiveVideoId] = useState(null);
  const token = localStorage.getItem('auth_token') || '';

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user_data")) || {};
    if (userData.isSuperAdmin) {
      navigate('/dashboard');
    }
  }, [navigate]);

  useEffect(() => {
    async function fetchSlider() {
      setLoading(true);
      try {
        const response = await getMediaByFolder('Slider', 1, 10);
        setSliderImages(response.data || []);
      } catch (error) {
        console.error('Fetch media error:', error);
      } finally {
        setLoading(false);
      }
    }
    fetchSlider();
  }, [])

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 350,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
    p: 3,
  };

  const nextSlide = () => {
    if (!adVideo.length) return;
    setActiveVideoId(null);
    setCurrentSlide((prev) => (prev + 1) % adVideo.length);
  };

  const prevSlide = () => {
    setActiveVideoId(null);
    setCurrentSlide((prev) => (prev === 0 ? adVideo.length - 1 : prev - 1));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      toast.error('No file selected.');
      return;

    }

    setPrescription(file);
    setUploadStatus('File ready for upload.');
  };

  const handleUpload = async (e) => {
    e.preventDefault()

    if (!prescription) {
      toast.error('Please select a file first.');
      return;
    }

    const userId = JSON.parse(localStorage.getItem('user_data'))?.id;

    try {
      setUploadStatus('Uploading...');

      const response = await uploadPrescription(prescription, userId);
      setUploadStatus(`Uploaded successfully! Media ID: ${response.id}`);
      toast.success('Uploaded successfully!');
      handleCloseModal();
    } catch (error) {
      setUploadStatus('Upload failed.');
      toast.error('Upload failed: ' + error.message);
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      if (adVideo.length > 0) {
        setActiveVideoId(null);
        setCurrentSlide((prev) => (prev + 1) % adVideo.length);
      }
    }, 5000);

    return () => clearInterval(timer);
  }, [adVideo]);

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const data = await getAllCategories(1, 30);
        const categories = data?.data || [];
        setCategory(categories);
      } catch (error) {
        console.error('Error fetching categories:', error);
        setCategory([]);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  /* useEffect(() => {
     const fetchProducts = async () => {
       setLoading(true);
       try {
         const firstPage = await getAllProductsByPage(1, 12);
         const totalPages = firstPage.totalPages || 1;
 
         const randomPage = Math.floor(Math.random() * totalPages) + 1;
 
         const { data } = await getAllProductsByPage(randomPage, 12);
 
         const shuffled = data.sort(() => Math.random() - 0.5);
 
         setProducts(shuffled.slice(0, 12));
       } catch (error) {
         console.error('Error fetching random products:', error);
         setProducts([]);
       } finally {
         setLoading(false);
       }
     };
 
     fetchProducts();
   }, []);*/
  /*useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);

      try {
        // Load all products (Instant if cached in localStorage)
        const allProducts = await getAllProducts();

        if (!allProducts || allProducts.length === 0) {
          setProducts([]);
          return;
        }

        // Shuffle all products
        const shuffled = [...allProducts].sort(() => Math.random() - 0.5);

        // Pick 12 random products
        setProducts(shuffled.slice(0, 12));

      } catch (error) {
        console.error("Error fetching random products:", error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);*/

  // REMOVED: a `getAllProductsByPage(1, 12)` fetch that filled the old
  // "Featured products" grid. Each CategoryRail now fetches its own products,
  // and does so lazily, so this request had no remaining consumer — it would
  // have been one more page-load cost for a grid nobody sees.

  useEffect(() => {
    async function fetchAdVideos() {
      setLoading(true);
      try {
        const response = await getMediaByFolder('AdVideos', 1, 5);
        console.log('fetched media:', response.data)
        setAdVideo(response.data || []);

      } catch (error) {
        console.error('Fetch media error:', error);

      }
      finally {
        setLoading(false);
      }
    }
    fetchAdVideos();
  }, []);
  
  // REMOVED: a prefetch that pulled the entire catalogue 4 seconds after every
  // landing, to warm the IndexedDB cache.
  //
  // That was reasonable when every listing page needed the full catalogue to do
  // its own filtering. Now that listings are paged server-side (PERF-1), the
  // full catalogue is only needed by the A–Z filter — so prefetching it for
  // every visitor spends the largest download in the app on a path most of them
  // never take. The A–Z filter fetches it on first use instead, and it is still
  // cached from then on.


  /* Which categories get a shelf, and in what order.
     - `uncategorized` is a WordPress artefact, not a department.
     - A category with no products would render an empty row, so it is dropped
       here rather than inside the rail. Note the Store API already hides empty
       categories by default, so this is belt-and-braces for a future change
       that passes `hide_empty: false`.
     - Biggest first, so the page opens on well-stocked shelves. The two
       largest are fetched eagerly; everything below loads on approach. */
  const railCategories = React.useMemo(
    () =>
      (category || [])
        .filter((c) => c?.slug && c.slug !== 'uncategorized' && (c.count ?? 0) > 0)
        .sort((a, b) => (b.count ?? 0) - (a.count ?? 0)),
    [category]
  );

  function navigateCategoryPage(slug) {
    if (!slug) return;
    navigate(`/category/${slug}`);
  }

  const handleOpen = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
    setPrescription(null);
    setUploadStatus('');
  };

  return (
    <div className="home">

      {/* ---------------- HERO SECTION ---------------- */}
      <section className="hero">
        <div className="hero-container">
          <div className="hero-left">
            <span className="tag">Trusted Local & Online Pharmacy</span>

            <h1>Your trusted neighborhood pharmacy — fast, safe, and reliable care</h1>

            <p className="hero-desc">
              Order medicines, vitamins, and healthcare essentials with certified
              pharmacists. Upload prescriptions, track orders, and get doorstep
              delivery.
            </p>

            <div className="hero-buttons">
              <a className="btn-white" href="/products">Shop Now</a>
              <a className="btn-outline" href="#refill">Refill Prescription</a>
            </div>

            <div className="hero-features">
              <div className="feature-box">
                <div className="feature-icon">🏥</div>
                <div>
                  <p className="feature-title">Licensed Pharmacists</p>
                  <p className="feature-subtitle">On duty 7 days</p>
                </div>
              </div>

              <div className="feature-box">
                <div className="feature-icon">🚚</div>
                <div>
                  <p className="feature-title">Home Delivery</p>
                  <p className="feature-subtitle">Same-day in city</p>
                </div>
              </div>

              <div className="feature-box">
                <div className="feature-icon">🔒</div>
                <div>
                  <p className="feature-title">Secure Payments</p>
                  <p className="feature-subtitle">Multiple options</p>
                </div>
              </div>

              <div className="feature-box">
                <div className="feature-icon">💬</div>
                <div>
                  <p className="feature-title">Support</p>
                  <p className="feature-subtitle">WhatsApp & Phone</p>
                </div>
              </div>
            </div>
          </div>

          <div className="hero-right">
            <div className="carousel-window">
              <div
                className="carousel-track"
                style={{ transform: `translateY(-${currentSlide * 100}%)` }}
              >
                {adVideo.length > 0 ? (
                  adVideo.map((ad) => (
                    <div className="carousel-item" key={ad.id}>
                      <AdVideoCard
                        ad={ad}
                        isActive={activeVideoId === ad.id}
                        onActivate={setActiveVideoId}
                        onDeactivate={() => setActiveVideoId(null)}
                      />
                    </div>
                  ))
                ) : (
                  <div className="carousel-item no-video-ad-card">
                    <p>No video ads available!</p>
                  </div>
                )}
              </div>

              <div className="carousel-controls">
                <button className="control-btn" onClick={prevSlide}>▲</button>

                <div className="dots-container">
                  {adVideo.map((_, idx) => (
                    <span
                      key={idx}
                      className={`dot ${currentSlide === idx ? 'active' : ''}`}
                      onClick={() => {
                        setActiveVideoId(null);
                        setCurrentSlide(idx);
                      }}
                    ></span>
                  ))}
                </div>

                <button className="control-btn" onClick={nextSlide}>▼</button>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* ---------------- SHOP BY CATEGORY ---------------- */}
      <section className="section">
        <h2 className="section-title">Shop by category</h2>

        <div className="category-grid">
          {category && Array.isArray(category) ? (
            category.map((item, index) => (
              item.name !== "Uncategorized" ? (
                <div
                  key={index}
                  className="category-card"
                  onClick={() => navigateCategoryPage(item.slug)}
                >
                  <div className="category-card-image-wrapper">
                    {item.image && item.image.src ? (
                      <img
                        src={item.image.src}
                        alt={item.name}
                        loading="lazy"
                      />
                    ) : (
                      <div className="no-image">
                        {item.name.charAt(0).toUpperCase()}
                      </div>
                    )}
                  </div>
                  <h5>{item.name}</h5>
                </div>
              ) : null
            ))
          ) : (
            <div style={{
              padding: '40px',
              textAlign: 'center',
              color: '#999',
              gridColumn: '1 / -1'
            }}>
              No categories available
            </div>
          )}
        </div>
      </section>

      {/* Picture Carousel */}
      <section className="slider">
        <Carousel className="carousel" dots={true} arrows={false} autoplay={{ 500: true }}>
          {sliderImages.length > 0 ? (
            sliderImages.map((item) => (
              <div key={item.id}>
                <img src={item.url} className="c-desktop" alt="" />
              </div>
            ))
          ) : (
            <p>No images available!</p>
          )}
        </Carousel>
      </section>

      {/* ---------------- A SHELF PER CATEGORY ----------------
          Replaces a single "Featured products" grid that showed the first 12
          products of the whole catalogue. Because the catalogue is ordered by
          date, those 12 were arbitrary and had no relationship to each other —
          it read as a shelf but was really just "the newest rows in the table".

          Each rail fetches its own products only as it approaches the viewport,
          so a visitor who lands and leaves pays for two requests, not sixteen.
          See CategoryRail for why that matters here specifically. */}
      {railCategories.map((cat, index) => (
        <CategoryRail
          key={cat.id}
          category={cat}
          isAuthenticated={isAuthenticated}
          onAddToCart={onAddToCart}
          eager={index < 2}
        />
      ))}

      {/* Keeps a route to the full catalogue now that the Featured grid's
          "View all" button is gone. */}
      {railCategories.length > 0 && (
        <section className="section" style={{ paddingTop: 24, textAlign: 'center' }}>
          <a className="view-all-btn" href="/products">Browse all products</a>
        </section>
      )}

      {/* ---------------- REFILL PRESCRIPTION ---------------- */}
      <section className="section" id="refill">
        <div className="refill-box">

          <div className="refill-left">
            <h3 className="refill-title">Refill your prescription</h3>
            <p className="refill-text">
              Upload a photo or PDF of your prescription, tell us what you need,
              and we'll handle the rest. Safe and discreet.
            </p>
          </div>

          <div className="refill-right">
            <button
              className="btn-blue"
              style={{ padding: "10px 20px" }}
              onClick={handleOpen}
            >
              Upload Prescription
            </button>
          </div>

        </div>
      </section>
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 380,
            bgcolor: "#fff",
            borderRadius: "16px",
            boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
            p: 3.5,
          }}
        >
          {/* Title */}
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 2,
              color: "#1f2937",
            }}
          >
            Upload Prescription
          </Typography>

          {/* Camera Button */}
          <button
            type="button"
            onClick={() => document.getElementById("modal-camera-input").click()}
            style={{
              width: "100%",
              padding: "10px 14px",
              borderRadius: "10px",
              border: "1px solid #d1d5db",
              background: "#f9fafb",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              fontSize: "15px",
              cursor: "pointer",
            }}
          >
            <FaCamera size={18} />
            Use Camera
          </button>

          {/* Hidden Input */}
          <input
            id="modal-camera-input"
            type="file"
            accept="image/*"
            capture="environment"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />

          {/* File Input */}
          <div style={{ marginTop: "15px" }}>
            <input
              type="file"
              accept="image/jpeg,image/png,application/pdf,
        application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,
        application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              onChange={handleFileChange}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #e5e7eb",
                borderRadius: "10px",
                fontSize: "14px",
                background: "#fff",
              }}
            />
          </div>

          {/* Upload Status */}
          {uploadStatus && (
            <p
              style={{
                marginTop: "10px",
                color: uploadStatus.includes("Error") ? "red" : "green",
                fontSize: "14px",
              }}
            >
              {uploadStatus}
            </p>
          )}

          {/* Buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              marginTop: "25px",
            }}
          >
            <button
              type="button"
              onClick={handleCloseModal}
              style={{
                padding: "8px 16px",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                background: "#fff",
                color: "#374151",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Cancel
            </button>

            <button
              type="submit"
              onClick={handleUpload}
              style={{
                padding: "8px 18px",
                borderRadius: "8px",
                background: "#079060ff",
                color: "#fff",
                border: "none",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Upload
            </button>
          </div>
        </Box>
      </Modal>

      {/* ---------------- TESTIMONIALS ---------------- */}
      <section className="section">
        <h2 className="section-title">What customers say</h2>

        <div className="testimonial-grid">
          {[
            "Fast delivery and polite staff!",
            "Easy prescription upload and verification.",
            "Good prices and genuine medicines.",
          ].map((msg, i) => (
            <blockquote key={i} className="testimonial">
              <p>{msg}</p>
              <footer>— Customer</footer>
            </blockquote>
          ))}
        </div>
      </section>




      <a
        href="https://wa.me/919807200292?text=Hi,%20I%20would%20like%20to%20place%20an%20order"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-circle-btn"
      >
        <FaWhatsapp size={45} />
      </a>

    </div>
  );
}